export class ResponseUtils {

    public static isStatusSuccess(status: number): boolean {
        return status >= 200 && status < 300;
    }

    public static getFileName(header: string): string {
        const startIndex = header.indexOf('filename=') + 10; // 10 for 'filename=' string;
        const endIndex = header.length - 1;
        const filename = header.substring(startIndex, endIndex);
        return filename;
    }

}
